import { render, staticRenderFns } from "./WaitingBadge.vue?vue&type=template&id=108c5994&scoped=true"
import script from "./WaitingBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./WaitingBadge.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WaitingBadge.vue?vue&type=style&index=0&id=108c5994&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108c5994",
  null
  
)

export default component.exports